import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Secretaria, Secretario, SolicitacaoFerias } from '../../api.service';
import { ServicoPortariaFerias } from './servico-portaria-ferias';

@Component({
  selector: 'app-modal-portaria-ferias',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './modal-portaria-ferias.component.html',
  styleUrls: ['../../shared/modal-pesquisa-lista.component.css', './modal-portaria-ferias.component.css']
})
export class ModalPortariaFeriasComponent implements OnChanges {
  @Input() aberta = false;
  @Input() salvando = false;
  @Input() solicitacao: SolicitacaoFerias | null = null;
  @Input() secretarias: Secretaria[] = [];
  @Input() secretarios: Secretario[] = [];
  @Input() parecer = '';

  @Output() parecerChange = new EventEmitter<string>();
  @Output() fechar = new EventEmitter<void>();
  @Output() salvar = new EventEmitter<{
    secretariaId: string;
    periodoAquisitivo: string;
    dataInicio: string;
    dataFim: string;
  }>();
  @Output() exportar = new EventEmitter<SolicitacaoFerias>();

  secretariaId = '';
  periodoAquisitivo = '';
  dataInicio = '';
  dataFim = '';
  salva: SolicitacaoFerias | null = null;

  constructor(readonly servico: ServicoPortariaFerias) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['aberta'] || changes['solicitacao']) {
      this.reiniciarFormulario();
    }
  }

  get dias() {
    return this.servico.calcularDias(this.dataInicio, this.dataFim);
  }

  get gabinete() {
    return this.servico.nomeSecretaria(this.secretarias, this.secretariaId);
  }

  get secretario() {
    return this.servico.secretarioDaSecretaria(this.secretarios, this.secretariaId);
  }

  get formularioValido() {
    return !!this.secretariaId
      && this.servico.periodoAquisitivoValido(this.periodoAquisitivo)
      && !!this.dataInicio
      && !!this.dataFim
      && this.dias > 0;
  }

  mascararPeriodo() {
    this.periodoAquisitivo = this.servico.mascararPeriodoAquisitivo(this.periodoAquisitivo);
  }

  confirmarSalvar() {
    if (!this.formularioValido || this.salvando) {
      return;
    }
    this.salvar.emit({
      secretariaId: this.secretariaId,
      periodoAquisitivo: this.periodoAquisitivo,
      dataInicio: this.dataInicio,
      dataFim: this.dataFim
    });
  }

  marcarSalva(solicitacao: SolicitacaoFerias) {
    this.salva = solicitacao;
  }

  exportarDocumento() {
    if (this.salva) {
      this.exportar.emit(this.salva);
    }
  }

  private reiniciarFormulario() {
    this.salva = null;
    this.secretariaId = this.solicitacao?.secretariaId || this.secretarias[0]?.id || '';
    this.periodoAquisitivo = this.solicitacao?.periodoAquisitivo || '';
    this.dataInicio = this.solicitacao?.dataInicioPortaria || this.solicitacao?.dataInicio || '';
    this.dataFim = this.solicitacao?.dataFimPortaria || this.solicitacao?.dataFim || '';
  }
}
